// Imports Angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs/Rx';

// Imports Aplicacion
import { DRespuestaSimple, DError, DContextoMuisca, DServicio, DParametrosServicio, DTipoOperacionHttp } from '@dian/core';
import { DContextoUsuarioServicio } from '@dian/api-identidad';
import { DDiligenciamientoServicios, DFormatos, DFormato, DLink } from '@dian/api-diligenciamiento';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DListaDocumentos, DInfoResumenFormulario } from '@dian/api-formulario';
import { FechasService } from './../../utils/fechas.service';
import { DDocumentoEnDiligenciamientoVista } from './../../to/ddocumento-en-diligenciamiento-vista';
import { FiltroFormatosPipe } from './../../pipes/filtro-formatos.pipe';
import { MessageService } from './../../resources/services/message.service';

@Component({
    moduleId: module.id,
    selector: 'selector-component',    
    templateUrl: 'selector.component.html',
    styleUrls: ['selector.component.css'],
    providers: [
        DNotificacionServicio,
        DDiligenciamientoServicios,
        DServicio,
        FechasService,
        FiltroFormatosPipe
    ]
})

/**
 * Main class SelectorComponent
 * @class
 */
export class SelectorComponent implements OnInit {

    public busqueda = null; 
    public cargandoDocumentoEnDili:boolean = false;
    public cargandoDocumentosParaDili: boolean = false;
    public datosContexto: DContextoMuisca;  
    public documentoConsulta: string;
    public tipoDocumento: string;       
    public dDocumentosDiligenciamiento: Array<DDocumentoEnDiligenciamientoVista>;
    public dFormatosDiligenciamiento: DFormatos;    
    public mostrarNuevosForms = true;
    public mostrarEnDiligenciamientoForms = true;
    public pathConfiguracionImgs: string;
    public imgObjetos: any;
    public hayElementosCambiarios: boolean = true;
    public hayElementosTributarios: boolean = true;
    public hayElementosFizcalizacion: boolean = true;
    public hayElementosAduaneros: boolean = true;
    public hayElementosOtros: boolean = true;
    public selectedTab: number = 0;

    /**
     * @constructs SelectorComponent
     * @param {Router} router
     */
    constructor(
        private router: Router,
        private dNotificaciones: DNotificacionServicio,
        private dServicioREST: DDiligenciamientoServicios,
        private dContextoUsuarioServicio: DContextoUsuarioServicio,
        private dServicioCore: DServicio,
        private http: Http,
        private _sessionStorage: SessionStorageService,
        private _fechaUtil: FechasService,
        private _pipeFilter: FiltroFormatosPipe,
        private _messageObservable: MessageService
    ) {
        //this.pathConfiguracionImgs = './assets/configuracion/formatos-img.json'; 
        this.dDocumentosDiligenciamiento = new Array<DDocumentoEnDiligenciamientoVista>();
        this.dFormatosDiligenciamiento = new DFormatos();            
    }

    /**
     * Interface for on init document.
     * @interface
     */
    ngOnInit() {
        setTimeout(()=> {
            this.consultarDatosContexto();            
        }, 50);
    }

    public emitEvent(event: string) {
        this._messageObservable.sendMessage(event);
    }

    /**
    * @desc Funcion que obtiene los datos del contexto para conocer el nit del contribuyente
    */
    private consultarDatosContexto() {
        let observableServicio = this.dContextoUsuarioServicio.consultarContextoUsuarioMuisca();
        observableServicio.subscribe(
            res => {                
                this.datosContexto = <DContextoMuisca>res; 
                this.documentoConsulta = this.datosContexto.ANombrePropio ? this.datosContexto.NitUsuario : this.datosContexto.NitOrganizacion;
                this.tipoDocumento = this.datosContexto.ANombrePropio ? 'CC-' : 'NIT-';                
                //this.obtenerConfiguracionFormatos();    
                this.obtenerFormatos(this.tipoDocumento + this.documentoConsulta);            
            }
        );    
    }

    /**
    * @desc Function para obtener la configuración de los formatos que incluye las rutas a las imagenes
    */
    /*private obtenerConfiguracionFormatos() {
        let observable = this.dServicioCore.ejecutarServicioInternoURL(this.pathConfiguracionImgs);
        //let observable = this.http.get(this.pathConfiguracionImgs).map(res => res.json());
        observable.subscribe(
            res => {
                this.imgObjetos = res;
                this.obtenerFormatos(this.tipoDocumento + this.documentoConsulta);
            },
            error => {
                this.dNotificaciones.mostrarDialogoError("Error consultando la configuración de los formatos", error.mensaje);
            }
        );
    }*/

    /**
    * @desc Funcion que otiene los formatos para el contribuyente desde el serivio REST
    * @param {String} documento
    */
    private obtenerFormatos(documento: string) {       
        let fechaFormatos = this._sessionStorage.retrieve('FECHA_FORMATOS');
        let formatos = this._sessionStorage.retrieve('FORMATOS');
        let diffDias = this._fechaUtil.obtenerDiferenciaDiasEntreDosFechas(new Date(fechaFormatos), new Date());

        // Si los formatos estan en la memoria del navegador por mas de un dia de diferencia con respecto a la fecha actual se solicitan de nuevo al servicio del servidor
        if(fechaFormatos && formatos && diffDias === 0) {
            this.dFormatosDiligenciamiento = <DFormatos>formatos;   
            /*if (this.dFormatosDiligenciamiento.dFormatos.length)                    
                this.obtenerRecursosDocs();*/
        } else {
            let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
            let observableServicio = this.dServicioREST.consultarListaFormatos(documento, true);
            observableServicio.subscribe(
                res => {
                    let arrayFormatos = <DFormatos>res;                   
                    for (let i in arrayFormatos.dFormatos) {
                        if (arrayFormatos.dFormatos[i].visibleEnSelector) 
                          this.dFormatosDiligenciamiento.dFormatos.push(<DFormato>arrayFormatos.dFormatos[i]);                        
                    }              
                    
                    if (this.dFormatosDiligenciamiento.dFormatos.length) {
                        this._sessionStorage.store('FECHA_FORMATOS', new Date());
                        this._sessionStorage.store('FORMATOS', this.dFormatosDiligenciamiento); //Persiste el objeto para cargas futuras
                        //this.obtenerRecursosDocs();                    
                    }
                    precargaProceso.close();
                }, error => {
                    precargaProceso.close();
                    this.dNotificaciones.mostrarDialogoError("Error consultando los formatos", error.mensaje);
                }
            );
        }
    } 

    /**
    * @desc Funcion que obtiene los documentos que se encuentran en diligenciamiento
    */
    private obtenerRecursosDocs() {
        //let precargaProceso = this.dNotificaciones.mostrarDialogoCarga();
        this.cargandoDocumentoEnDili = true;
        let parametrosServicio = new DParametrosServicio();
        parametrosServicio.setOperacion(DTipoOperacionHttp.Consultar);
        let observablesServicios = [];
        let totalRecursos = 0;

        for(let i in this.dFormatosDiligenciamiento.dFormatos) {
            let formato = <DFormato>this.dFormatosDiligenciamiento.dFormatos[i];

            if (formato.soportaContratoURI) {
                let href = formato.recursoAPI.href;
                let observableServicio = this.dServicioCore.ejecutarServicioInternoURL(href + '/formularios?estado=pendiente');
                observableServicio.subscribe(
                    res => {},
                    error => {
                        totalRecursos++;
                        if(totalRecursos === observablesServicios.length) {
                            this.cargandoDocumentoEnDili = false;
                            //precargaProceso.close();
                        }
                    });
                observablesServicios.push(observableServicio); 
            }                
        }

        // Espera la respuesta de todos los servicios llamados por documento
        Observable
            .forkJoin(observablesServicios)
            .map((result) => {
                for (let i in result) {
                    let documentos = <DListaDocumentos>result[i]; 
                    for (let d in documentos.infoFormularios) {
                        let documentoVista = this.obtenerDocumentoCompleto(documentos.infoFormularios[d])                        
                        this.dDocumentosDiligenciamiento.push(documentoVista);
                    }
                } 
                this.cargandoDocumentoEnDili = false;
                //precargaProceso.close();           
            })            
            .subscribe();
    }

    /**
    * @desc Funcion para construir los objetos que se van a guardar en el array de documentos en diligenciamiento
    *
    */
    private obtenerDocumentoCompleto(formulario: DInfoResumenFormulario): DDocumentoEnDiligenciamientoVista {
        let formularioVista: DDocumentoEnDiligenciamientoVista = new DDocumentoEnDiligenciamientoVista();
        (<any>Object).assign(formularioVista, formulario);

        for (let i in this.dFormatosDiligenciamiento.dFormatos) {
            if (this.dFormatosDiligenciamiento.dFormatos[i].ideFormato === formulario.identificador.formato) {
                let formato = <DFormato>this.dFormatosDiligenciamiento.dFormatos[i];
                formularioVista.nombre = formato.nombre;
                formularioVista.descripcion = formato.descripcion;   
                formularioVista.vencimiento = new Date(formato.vencimiento);
                formularioVista.colorAlerta = this.verificarEstadoFormulario(formato.vencimiento);
                formularioVista.links = new Array<DLink>();
                formularioVista.links.push(formato.recurso);
                break;
            }
        }

        return formularioVista;
    }
   
    /**
     * Funcion que realiza los calculos para indicar la alerta en la tarjeta
     * @param {Any} vencimiento
     * @return {String} color under of card selector
     */
    public verificarEstadoFormulario(vencimiento: any): string {
        // #e0bc0b - amarillo
        // #e05a0b - rojo
        let expiracion = new Date(vencimiento);
        let fechaActual = new Date();
        let diffDias = this._fechaUtil.obtenerDiferenciaDiasEntreDosFechas(expiracion, new Date());
        //let diffDias = expiracion.getDate() - fechaActual.getDate();
        //return "#d4d3d3";
        return (diffDias > 0 && diffDias <= 5) ? '#e0bc0b' : diffDias === 0 ? '#e05a0b' : '#d4d3d3';
    }

    /**
     * Funcion para redireccionar segun el parametro tipo
     * @param {DFormato} formato
     * @param {String} tipo de redireccion (inicial = redirige a la parte inicial del formulario, formulario = redirige directamente al formulario)
     */
    public redireccionar(formato: any, tipo: string) {
        if (tipo === 'ingreso') {
            switch (formato.indTipoFormulario) {
                case 'A': //Angular                    
                    window.location.href = this.corregirRutaIngreso(4, 0, formato.recurso.href, 'DilIngreso');
                    break;
                case 'F': //Flex
                    window.location.href = window.location.origin + '/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=' + formato.ideFormato;
                    break;
                case 'V': //Visor
                    window.location.href = window.location.origin + '/WebDiligenciamiento/DefFormulariosContingencia.faces';
                    break;
            }            
            /*if (formato.soportaContratoURI) {
                // Redireccion sin es un formulario que esta habilitado para usar Angular
                window.location.href = formato.recurso.href;
            } else {
                // Redireccion sin es un formulario antiguo que no esta habilitado para usar Angular
                window.location.href = window.location.origin + '/WebDiligenciamiento/DefDiligenciamientoFormularios.faces?form=' + formato.ideFormato;
            }*/
        } else {
            let esCorreccion = formato.atributos.docAtributos.esPresentado ? 'correccion' : formato.modo;
            let queryStringParams = {
                concepto: esCorreccion,
                anio: formato.anio, 
                periodicidad: formato.periodicidad, 
                periodo: formato.periodo ? formato.periodo : "null",
                documento: formato.identificador.id
            };

            let parametros = new URLSearchParams();
            for(let key in queryStringParams){
                parametros.set(key, queryStringParams[key]) 
            }
            window.location.href = formato.links[0].href + '?' + parametros.toString();
        }
    }  

    /**
     * Funcion que realiza la busqueda de un formato para seleccionar la tab automaticamente
     */
    public obtenerGrupoFormatoBuscado() {
      let arr = this._pipeFilter.transform(this.dFormatosDiligenciamiento.dFormatos, this.busqueda);
      if (arr.length) {
        switch (arr[0].ideGrupo) {
          case 12960001: //Aduaneros
            this.selectedTab = 2;
            break;
          case 12960002: //Cambiarios
            this.selectedTab = 3;
            break;
          case 12960003: //Tributarios
            this.selectedTab = 0;
            break;
          case 12960004: //Fiscalización
            this.selectedTab = 1;
            break;
          case 12960005: //Otros
            this.selectedTab = 4;
            break;          
        }
      }      
    }

    /*
    * @desc Funcion temporal para corregir la ruta de ingreso de los formularios
    * @ignore
    */
    private corregirRutaIngreso(index, hasta, strOriginal, strAdicional) {
        return strOriginal.slice(0, index) + strAdicional + strOriginal.slice(index + Math.abs(hasta));
    }

}



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/components/selector/selector.component.ts